export default function DTD_Attributes() {
  return (
    <div>
      <h1>DTD_Attributes</h1>
      <p>This is the DTD_Attributes component.</p>
    </div>
  );
}